import axios, { AxiosRequestConfig } from 'axios';

export class AdvertisingApi {
    async getAdvertisingTypes() {
        let path = `/api/Communication`;
        try {
            if (window.isOffline) {
                return null;
            } else {
                const res = await axios.get(path);
                return res.data;
            }
        } catch (error) {
            throw error;
        }
    }

    async getAdvertisingList(advertising: number, limit: number = 20, offset: number = 0) {
        let path = `/api/Communication/${advertising}`;
        try {
            if (window.isOffline) {
                return null;
            } else {
                const res = await axios.get(path);
                return res.data;
            }
        } catch (error) {
            throw error;
        }
    }
}
